/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityKeyBIcon24Solid = forwardRef('SecurityKeyBIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 18.5a6.501 6.501 0 0 0 6.007-4.013.705.705 0 0 1 1.18-.105l.699.897a1 1 0 0 0 1.533.054l.803-.895a1 1 0 0 1 1.514.03l.703.848a1 1 0 0 0 1.524.019l1.992-2.288a1 1 0 0 0 .03-1.276l-1.739-2.205a1.5 1.5 0 0 0-1.178-.57h-7.303A6.5 6.5 0 1 0 7.5 18.5Zm0-4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" })));
});
